import React from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { DragHandle } from '../../../../../components/DragHandle/DragHandle';
import { ProductSettingsRow, type ProductSettingsRowProps } from './ProductSettingsRow';

type SortableProductRowProps = Omit<ProductSettingsRowProps, 'reorderMode' | 'rowRef' | 'rowStyle' | 'dragHandle'>;

// Architectural summary: reorder-only wrapper; owns useSortable so normal mode mounts zero dnd.
const SortableProductRowComponent: React.FC<SortableProductRowProps> = (props) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, transform, transition, isDragging } = useSortable({
    id: props.product.id,
  });
  const rowStyle: React.CSSProperties = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.6 : undefined,
  };
  const dragHandle = (
    <DragHandle
      dataTestId={`product-settings-drag-${props.product.id}`}
      attributes={attributes}
      listeners={listeners}
      setActivatorNodeRef={setActivatorNodeRef}
    />
  );
  return <ProductSettingsRow {...props} reorderMode rowRef={setNodeRef} rowStyle={rowStyle} dragHandle={dragHandle} />;
};

export const SortableProductRow = React.memo(SortableProductRowComponent);
